<template>
  <a-modal
    title="北望交易网服务协议"
    :visible="Agreementvisible"
    @cancel="handleCancel"
    width="1000px"
    :footer="null"
    class="Agreementvisible"
    centered
  >
    <h3>
      您在申请注册成为本平台用户前，应当认真阅读以下协议。为维护您的权益，请您务必审慎阅读、充分理解协议中的相关条款，尤其是：</h3>
    <h3>（1）免除或限制责任的条款；</h3>
    <h3>（2）法律适用和管辖的条款；</h3>
    <h3>（3）其他以粗体及下划线标注的重要条款。</h3>
    <p>
      当您按照注册页面提示填写信息、阅读并同意协议并完成全部注册流程后，即表示您已经充分阅读、理解并接受协议的全部内容。如您因平台服务与北望交易网平台发生争议，适用《北望交易网服务协议》处理；如您在使用平台服务过程中与其他用户发生争议的，依照您与其他用户达成的协议处理。</p>
    <h3>如在注册过程中您不同意《北望交易网服务协议》的任何条款约定，您应立即停止注册；如您对协议有任何疑问，可向平台客服咨询。</h3>
    <h3>1.签约主体</h3>
    <p>
      本协议由您与北望交易网平台经营者（广州出云科技有限公司，以下称北望交易网）共同签订，对您与北望交易网平台经营者均具有法律约束力。本协议项下的北望交易网平台经营者可能根据平台的业务调整而发生变更，变更后的北望交易网平台经营者与您共同履行本协议并向您提供服务，北望交易网平台经营者的变更不会影响您本协议项下的权益。北望交易网平台经营者还有可能因为提供新的平台服务而新增，如您使用新增的平台服务的，视为您同意新增的平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。</p>
    <h3>2.补充协议</h3>
    <p>
      由于互联网高速发展，您与北望交易网签署的本协议列明的条款并不能完整罗列并覆盖您与北望交易网所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，北望交易网平台法律声明及隐私权政策、北望交易网平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用北望交易网平台服务，视为您同意上述补充协议。</p>
    <h3>3.平台账户</h3>
    <p>
      您确认，在您开始注册程序使用北望交易网平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。您注册成功后，北望交易网平台将为您开通一个账户，作为您在北望交易网平台交易及使用北望交易网平台服务时的唯一身份标识，该账户的登录名和密码由您负责保管。您有责任对您的账户和密码保守秘密，并且您同意对在您的账户和密码下发生的所有活动承担责任。用户在申请使用北望交易网平台服务时，必须准确提供必要的资料，如资料有任何变动，请在北望交易网平台及时更新。</p>
    <h3>4.合同的成立</h3>
    <p>
      当您在北望交易网平台购买商品及/或服务时，请您务必仔细确认所购商品的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。</p>
    <h3>在您下单后，销售方将会对您的订单进行确认，并生成电子货物买卖合同，您对该合同进行确认后，即视为您与销售方就确认的订单成立合同关系。您与销售方之间的权利义务关系以货物买卖合同约定为准。</h3>
    <p>在销售方与您的货物买卖合同成立之前，您与销售方均有权取消相关商品的订单。订单取消后，如您已支付款项，已支付的款项将退回您的付款账户。</p>
    <h3>5.责任限制</h3>
    <p>北望交易网依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，北望交易网并不承担相应的违约责任：</p>
    <p>（一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
    <p>（二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
    <p>（三）在北望交易网已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
    <h3>6.协议变更</h3>
    <h3>
      平台运营方有权根据法律法规调整及平台运营需要不定期修订本协议；修改后的协议条款将向您予以公示，公示期不低于7天，并代替原来的协议；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受变更后的协议内容，也将遵守变更后的协议内容使用北望交易网平台服务；如果您不接受修订的内容，需立即停止接受北望交易网平台提供的服务。</h3>
    <h3>7.法律适用、管辖其效力</h3>
    <h3>本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
      您因使用北望交易网平台服务所产生及与北望交易网平台服务有关的争议，由北望交易网与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</h3>
    <p>本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
    <h3>8.通知与送达</h3>
    <p>
      您在注册成为北望交易网平台用户，并接受北望交易网平台服务时，您应该向北望交易网提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。</p>
    <h3>
      北望交易网通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在北望交易网平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，发送系统消息以及站内信信息等，在发送成功后即视为送达；以纸质载体发出的书面通知，按照您提供的联系地址交邮后的第五个自然日即视为送达。</h3>
    <h3>
      对于在北望交易网平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在北望交易网平台注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</h3>
  </a-modal>
</template>

<script>
  export default {
    name: 'Agreement',
    data() {
      return {
        Agreementvisible: false
      }
    },
    methods: {
      handleCancel() {
        this.Agreementvisible = false
      }
    }
  }
</script>

<style scoped>

</style>